import axios from "axios";
import { handleActions } from "redux-actions";

import Config from "config";
import { getHeaders } from "helpers/headers";
import { AnyAction } from "interfaces/action";
import { Dispatch } from "interfaces/dispatch";
import { ThunkActionCreator } from "interfaces/thunk";

// Action Types
export const FETCH_STARRED_PROJECTS_REQUEST = "FETCH_STARRED_PROJECTS_REQUEST";
export const FETCH_STARRED_PROJECTS_SUCCESS = "FETCH_STARRED_PROJECTS_SUCCESS";
export const FETCH_STARRED_PROJECTS_FAILURE = "FETCH_STARRED_PROJECTS_FAILURE";
export const PROJECT_STAR_TOGGLE_REQUEST = "PROJECT_STAR_TOGGLE_REQUEST";
export const PROJECT_STAR_TOGGLE_SUCCESS = "PROJECT_STAR_TOGGLE_SUCCESS";
export const PROJECT_STAR_TOGGLE_FAILURE = "PROJECT_STAR_TOGGLE_FAILURE";

// Thunk Action Creators
export const fetchStarredProjects: ThunkActionCreator<Promise<void>> = (userId: string, page?: string, pageCount?: string) => (dispatch: Dispatch) => {
    dispatch({ type: FETCH_STARRED_PROJECTS_REQUEST });
    let url = `${Config.API_SERVICE_URL}/api/starred-projects?userId=${userId}`;

    if (page) url += `&page=${page}`;
    if (pageCount) url += `&pageCount=${pageCount}`;

    return axios
        .get(url, getHeaders())
        .then(response => {
            dispatch({ type: FETCH_STARRED_PROJECTS_SUCCESS, payload: response.data });
        })
        .catch( error => {
            dispatch({ type: FETCH_STARRED_PROJECTS_FAILURE, payload: error });
        });
};
export const toggleStarredProject: ThunkActionCreator<Promise<void>> = (project: any) => (dispatch: Dispatch) => {
    dispatch({ type: PROJECT_STAR_TOGGLE_REQUEST, payload: project });
    
    return axios
        .post(
            `${Config.API_SERVICE_URL}/api/starred-projects`,
            project,
            getHeaders()
        )
        .then(response => {
            dispatch({ type: PROJECT_STAR_TOGGLE_SUCCESS, payload: response.data });
        })
        .catch( error => {
            dispatch({ type: PROJECT_STAR_TOGGLE_FAILURE, payload: error });
        });
};

// Actions
const actions = {
    [FETCH_STARRED_PROJECTS_REQUEST]: (state: StarredProjectsState) => ({
        ...state,
        loading: true,
    }),
    [FETCH_STARRED_PROJECTS_SUCCESS]: (state: StarredProjectsState, action: AnyAction) => {
        return {
            ...state,
            content: action.payload,
            loading: false,
            error: false,
        };
    },
    [FETCH_STARRED_PROJECTS_FAILURE]: (state: StarredProjectsState) => ({
        ...state,
        loading: false,
        error: true,
    }),
    [PROJECT_STAR_TOGGLE_REQUEST]: (state: StarredProjectsState, action: AnyAction) => {
        const project = action.payload;
        const starredProjectExists = state.content.findIndex(p => p.project_id === project.project_id) > -1;
        let content = starredProjectExists
            ? state.content.map(p => p.project_id === project.project_id ? {...p, ...project} : p)
            : [ ...state.content, project ]
        content = content.filter(p => p.starred);

        return {
            ...state,
            content,
            loading: true,
        }
    },
    [PROJECT_STAR_TOGGLE_SUCCESS]: (state: StarredProjectsState, action: AnyAction) => {
        console.log(action.payload);
        
        return {
            ...state,
            loading: false,
            error: false,
        }
    },
    [PROJECT_STAR_TOGGLE_FAILURE]: (state: StarredProjectsState) => ({
        ...state,
        loading: false,
        error: true,
    }),
};

// Reducer Interface
// TODO: Add type to content
export interface StarredProjectsState {
    content: any[];
    error?: boolean;
    loading?: boolean;
}

// Initial State
const initialState: StarredProjectsState = {
    loading: false,
    error: false,
    content: [],
};

// Reducer
export default handleActions<StarredProjectsState, AnyAction>(actions, initialState);